import { render, staticRenderFns } from "./InstructionalMethodForm.vue?vue&type=template&id=4bccd33d&scoped=true"
import script from "./InstructionalMethodForm.vue?vue&type=script&lang=js"
export * from "./InstructionalMethodForm.vue?vue&type=script&lang=js"
import style0 from "./InstructionalMethodForm.vue?vue&type=style&index=0&id=4bccd33d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bccd33d",
  null
  
)

export default component.exports